<template>
  <h2 class="payment-method mb-3">{{ title }}</h2>
</template>

<script>
import { getPaymentMethodTitle } from "@/services/orderPageSectionTitles";

export default {
  name: "CheckoutPaymentMethodTitle",
  computed: {
    title() {
      return getPaymentMethodTitle(this.$i18n?.locale);
    },
  },
};
</script>
